import { render, staticRenderFns } from "./ServiceNavbar.vue?vue&type=template&id=59bc2ff6&scoped=true"
import script from "./ServiceNavbar.vue?vue&type=script&lang=js"
export * from "./ServiceNavbar.vue?vue&type=script&lang=js"
import style0 from "./ServiceNavbar.vue?vue&type=style&index=0&id=59bc2ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc2ff6",
  null
  
)

export default component.exports